import { render } from "./ErrorExternalLinks.vue?vue&type=template&id=e756b6ca&scoped=true&ts=true"
import script from "./ErrorExternalLinks.vue?vue&type=script&lang=ts"
export * from "./ErrorExternalLinks.vue?vue&type=script&lang=ts"

import "./ErrorExternalLinks.vue?vue&type=style&index=0&id=e756b6ca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e756b6ca"]])

export default __exports__